import script from "./SwitchUserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchUserDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__